import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ContactService {
 api = `${environment.restAPIUrl}/api/public`
  constructor(private http:HttpClient) { }

  postContact(obj){
    return this.http.post(`${this.api}/sendContactUs`,obj);
  }
   
}
